export const send_terminal_command = (device_id, text) => async (dispatch) => {
    const request_id = Math.random().toString().substring(2);
    dispatch(send_terminal_command_with_request_id(device_id, text, request_id));
};
export const send_terminal_command_with_request_id = (device_id, text, request_id) => async (dispatch, getState, { api, comet }) => {
    const session_id = comet.session_id();
    if (session_id == null) {
        dispatch({
            type: 'GOT_TERMINAL_RESPONSE',
            device_id,
            request_id,
            ok: false,
            text: 'Нет соединения с сервером',
        });
        return;
    }
    dispatch({ type: 'SEND_TERMINAL_COMMAND', device_id, request_id, text });
    comet.listen({
        once: true,
        event: 'text_response',
        condition: {
            request_id,
        },
        callback(response) {
            dispatch({
                type: 'GOT_TERMINAL_RESPONSE',
                device_id,
                request_id,
                ok: response.ok,
                text: response.text,
            });
        },
    });
    try {
        await api.send_text_to_device(device_id, text, session_id, request_id);
    }
    catch (error) {
        const { json } = error;
        dispatch({
            type: 'GOT_TERMINAL_RESPONSE',
            device_id,
            request_id,
            ok: false,
            text: json?.error_ui,
            failure: json,
        });
    }
};
export const apply_debug_text_message = (device_id, text) => ({
    type: 'APPLY_DEBUG_TEXT_MESSAGE',
    device_id,
    text,
});
